export default __webpack_public_path__ + "images/TK.9ac70e7.png";